import { render, staticRenderFns } from "./MissionSubmitIcon.vue?vue&type=template&id=20754d2c"
import script from "./MissionSubmitIcon.vue?vue&type=script&lang=ts"
export * from "./MissionSubmitIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports